import { ReactElement } from "react";

import { TooltipPlacementName } from "../Pagination/types/types";
import Tooltip from "./Tooltip";

interface OptionalTooltipProps {
  children: ReactElement<any, any>;
  isDisabled: boolean;
  tooltipTitle: string;
  tooltipPlacement: TooltipPlacementName;
  defaultWordBreak?: boolean;
  disableInteractive?: boolean;
  disableTouchListener?: boolean;
}

const OptionalTooltip = ({
  children,
  isDisabled,
  tooltipTitle,
  tooltipPlacement,
  defaultWordBreak,
  disableInteractive,
  disableTouchListener
}: OptionalTooltipProps) => {
  if (!isDisabled) {
    return (
      <Tooltip
        disableInteractive={disableInteractive}
        disableTouchListener={disableTouchListener}
        title={tooltipTitle}
        size="medium"
        placement={tooltipPlacement}
        customWordBreak={defaultWordBreak ? undefined : "break-all"}
      >
        {children}
      </Tooltip>
    );
  }
  return children;
};

export default OptionalTooltip;
